module.exports = __webpack_public_path__ + "img/home1.3cb3e375.png";